import React, { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import InviteCarriers from 'components/InviteCarriers'
import { fetchRFPById } from 'features/requestForProposalList/actions'
import {
  rfpDetailSelector,
  rfpDetailIsLoadingSelector,
} from 'features/requestForProposalList/selectors'
import { fetchCarriers } from 'features/carriers/actions'
import {
  fetchInvites,
  toggleCarrierInvite,
} from 'features/carrierInvites/actions'
import {
  carriersInvitedSelector,
  carrierInvitesIsLoadingSelector,
} from 'features/carrierInvites/selectors'

import Header from './Header'

const Page = styled.div`
  a {
    text-decoration: none;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.colors.text};

    :visited {
      color: ${({ theme }) => theme.colors.text};
    }
  }
`

export default function RFPCarriers() {
  const { rfpId } = useParams<{ rfpId: string }>()
  const dispatch = useDispatch()

  const rfp = useSelector(rfpDetailSelector)
  const rfpIsLoading = useSelector(rfpDetailIsLoadingSelector)
  const isLoadingInvites = useSelector(carrierInvitesIsLoadingSelector)
  const invitedCarriers = useSelector(carriersInvitedSelector)

  const toggleCarrier = useCallback(
    (carrier: Carrier, isSelected: boolean) => {
      dispatch(toggleCarrierInvite(carrier, +rfpId, isSelected))
    },
    [dispatch, rfpId]
  )

  useEffect(() => {
    dispatch(fetchRFPById(rfpId))
    dispatch(fetchCarriers())
    dispatch(fetchInvites(rfpId))
  }, [dispatch, rfpId])

  return (
    <Page>
      <Header rfp={rfp} isLoading={rfpIsLoading} />
      <InviteCarriers
        rfpState={rfp?.state}
        isLoading={isLoadingInvites}
        selectedCarriers={invitedCarriers}
        toggleCarrier={toggleCarrier}
        rfpId={+rfpId}
      />
    </Page>
  )
}
